import {Component} from 'react';
import {WebSocketsClient} from "./WebSocketsClient";

export class WebSocketEvent extends Component {
    componentDidMount() {
        this._channel = WebSocketsClient.subscribe(this.props.channelId);
        this._channel.bind(this.props.eventId, this.props.onEventTriggered);
    }

    componentWillUnmount() {
        this._channel.unbind(this.props.eventId);
    }

    render() {
        return null;
    }
}